import React from 'react';
import bgImage from '../../../assets/images/bg-card-img.png';
import { CardBoxStyle } from './InfoSection.styles';

const CardBox = ({ arr }) => {
  return (
    <>
      {arr?.map((item, index) => (
        <CardBoxStyle>
          <div className="text-box">
            <strong className="title">{item?.title}</strong>
            <p>{item.description}</p>
            <button className="btn" onClick={item?.onClick} style={{ backgroundColor: item?.btnColor }}>
              {item.btn}
            </button>
          </div>
          <div className="img-box" key={index}>
            <img src={item?.icon} width="90" alt="icon" />
          </div>
        </CardBoxStyle>
      ))}
    </>
  );
};

export default CardBox;
